import script from "./NotificationToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationToast.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationToast.vue?vue&type=style&index=0&id=3b983f2f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b983f2f"]])

export default __exports__